/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useDispatch /* useSelector */ } from 'react-redux';
import localeManager from 'intl/LocalesManager';
import mProduct from 'models/product';
import styles from './style.cssmodule.css';

const product = __PRODUCT__; // eslint-disable-line no-undef
const productAvailableLocales = localeManager.getAvailableLocales().filter(({ locale }) => mProduct.getAuthorizedLocales(product).includes(locale));

function LangSelector2() {
  const dispatch = useDispatch();

  const handleLocaleChange = (newLocale) => {
    dispatch({ type: 'CHANGE_LOCALE', locale: newLocale });
  };

  return (
    <div className={styles.langSelector}>
      {productAvailableLocales.map(({ language, locale: availableLocale }) => <span key={language} className={styles.lang} onClick={() => handleLocaleChange(availableLocale)}>{language}</span>)}
    </div>
  );
}

export default LangSelector2;



// WEBPACK FOOTER //
// ./components/LangSelector2/LangSelector2.jsx